/* eslint-disable no-param-reassign */
import { rgba } from 'polished';

const blackAlpha = {
  50: 'rgba(0, 0, 0, 0.08)',
  100: ' rgba(0,0, 0, 0.1)',
  200: ' rgba(0, 0, 0, 0.16)',
  300: ' rgba(0, 0, 0, 0.25)',
  400: ' rgba(0, 0, 0, 0.3)',
  500: ' rgba(0, 0, 0, 0.36)',
  600: ' rgba(0, 0, 0, 0.48)',
  700: ' rgba(0, 0, 0, 0.64)',
  800: ' rgba(0, 0, 0, 0.8)',
  900: ' rgba(0, 0, 0, 0.92)',
};

const voicetube = {
  800: '#18131D',
  700: '#190f23',
  600: '#251633',
  500: '#210040',
  400: '#7e3aaf',
  300: '#a73aaf',
  200: '#e0d0ec',
  100: '#eadef2',
};

const hero = {
  600: '#00abb2',
  500: '#00bbc3',
  400: '#4acfd1',
  300: '#b1ebe9',
  200: '#dff7f6',
};

const vclass = {
  600: '#c3421b',
  500: '#eb5f34',
  400: '#fbe1d5',
};

const blue = {
  700: '#385f99',
  600: '#2a66c1',
  500: '#4283e4',
  400: '#679be9',
  300: '#e8f0fb',
  200: `${rgba('#4283e4', 0.16)}`,
};

const gray = {
  600: '#787878',
  500: '#949494',
  400: '#b4b4b4',
  300: '#e3e3e3',
  200: '#f3f3f3',
};

const red = {
  600: '#be3338',
  500: '#ed4f55',
};

const green = {
  600: '#268969',
  500: '#37c597',
};

const dark = {
  700: '#111111',
  600: '#191919',
  500: '#2b2b2b',
  400: '#333333',
};

const yellow = {
  500: '#ffb900',
};

const orange = {
  500: '#ed7d4f',
};

const colors = {
  voicetube,
  hero,
  vclass,
  gray,
  dark,
  blue,
  red,
  yellow,
  green,
  orange,
  'black-alpha': blackAlpha,
  white: '#ffffff',
  black: '#000000',
};

export default colors;
